module.exports = __webpack_public_path__ + "img/data-decentralization-privatesale.e01a51ef.png";